<template>
  <v-card color="#E0E0E0">
    <apexcharts ref="chart" type=line height=600 :options="chartOptions" :series="series" />
  </v-card>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  import moment from 'moment'
  import pdfMake from 'pdfmake'
  const fonts = require('pdfmake/build/vfs_fonts')
  pdfMake.vfs = fonts.pdfMake.vfs


  export default {
    name: 'BacklogGraph',
    components: {
      apexcharts: VueApexCharts,
    },
    data: function() {
      return {
        series: [],
        chartOptions: {
          chart: {
            background: 'transparent',
            zoom: {
              enabled: false
            },
          },
          theme: {
            mode: (this.$store.state.darktheme) ? 'light' : 'light'
          },
          tooltip: {
            theme: (this.$store.state.darktheme) ? 'dark' : 'light'
          },
          colors: ['#0000ff', '#0fde00', '#d1c700', '#ff0000'],
          fill: {
            colors: ['#0000ff', '#0fde00', '#faf148', '#ff0000']
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            width: [5, 7, 5, 5],
            curve: 'straight',
            dashArray: [4, 12, 0, 0]
          },

          title: {
            text: 'Backlog',
            align: 'left'
          },
          markers: {
            size: [0, 0, 0, 5],

            hover: {
              sizeOffset: 6
            }
          },
          xaxis: {
            type: 'datetime'
          },
          grid: {
            borderColor: '#f1f1f1',
          }
        },
        // for pdf table
        dates: [],
        screened: null,
        done: null,
        backlog: null,
      }
    },
    props: {
      finalDate: {
        type: Date,
      }
    },
    computed: {
      themeMode () {
        return (this.$store.state.darktheme) ? 'dark' : 'light'
      }
    },
    watch: {
      themeMode (newVal) {
        this.chartOptions.theme.mode = newVal
        this.chartOptions.tooltip.theme = newVal
      }
    },
    methods: {
      generateGraphPDF () {
        this.$refs.chart.dataURI().then(uri => {
          const today = new Date()
          const dd = {
            pageSize: 'A5',
            pageOrientation: 'landscape',
            content: [
              {
                text: [
                  {text: `Backlog as of ${today.getMonth() + 1}/${today.getDate()}`, fontSize: 16}
                ]
              },
              {
                layout: 'noBorders',
                table: {
                  style: 'tableExample',
                  body: [
                    this.dates,
                    this.screened,
                    this.done,
                    this.backlog
                  ]
                }
              },
              {
                image: 'graph',
                width: 525
              }
            ],
            images: {
              graph: uri
            },
            styles: {
              tableExample: {
                fontSize: 4
              }
            }
          }
          pdfMake.createPdf(dd).download(`backlog_${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`);
        })
      },
      loadGraph() {
        this.$http.get('/statistics/backlog', {
          headers: {'Authorization': localStorage.getItem('apiKey')}
        }).then((result) => {
          let weeks = result.data
          console.log(weeks)

          let screened = []
          let done = []
          let backlog = []
          let redline = []

          const pdfTableFontSize = 5

          for(let el in weeks) {
              let week = weeks[el]
              let enddate = moment(week.enddate).toDate()
              this.dates.push({text: moment(week.enddate).format('MM/DD/YY'), fontSize: pdfTableFontSize})
              screened.push([enddate, week.screened])
              done.push([enddate, week.done])
              backlog.push([enddate, week.backlog])
              redline.push([enddate, week.redline === 0 ? null : week.redline])
          }

          // for pdf
          this.screened = screened
          this.done = done
          this.backlog = backlog

          this.screened = this.screened.map(e => {return {text: e[1], fontSize: pdfTableFontSize}})
          this.done = this.done.map(e => {return {text: e[1], fontSize: pdfTableFontSize}})
          this.backlog = this.backlog.map(e => {return {text: e[1], fontSize: pdfTableFontSize}})

          this.dates.unshift({text: '', fontSize: pdfTableFontSize})
          this.screened.unshift({text: 'Screened', fontSize: pdfTableFontSize})
          this.done.unshift({text: 'Done', fontSize: pdfTableFontSize})
          this.backlog.unshift({text: 'Backlog', fontSize: pdfTableFontSize})

          // for graph
          this.series = [{
            name: "Screened",
            data: screened
          },
            {
              name: "Done",
              data: done
            },
            {
              name: 'Backlog',
              type: 'area',
              data: backlog
            },
            {
              name: 'Redline',
              data: redline
            },
          ]
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/graphs/BacklogGraph.vue